<template>
  <ResultsNotices v-if="visible" :payload="payload" :current-website="settings.currentWebsite" :has-parts="hasParts">
    <slot ref="parts"></slot>
  </ResultsNotices>
</template>

<script setup>
import { computed, ref, useTemplateRef } from "vue";
import { useSlottedVisibility } from "#ce/apps/SpFinderResultNotices/composables/useSlottedVisibility";
import { whenI18nReady } from "#ce/components/SpFinder/i18n";
import { useFinderResults } from "#ce/components/SpFinder/composables/useFinderResults";
import ResultsNotices from "./components/ResultsNotices.ce.vue";

const catalogsReady = ref(false);

function markCatalogsReady() {
  catalogsReady.value = true;
}

whenI18nReady.then(markCatalogsReady);

const { settings, payload, view, mobile } = useFinderResults();
const { visible: hasParts } = useSlottedVisibility(useTemplateRef("parts"));

const visible = computed(
  () =>
    catalogsReady.value &&
    Boolean(payload.value) &&
    Boolean(settings.value?.notices) &&
    (mobile.value || view.value !== "map"),
);
</script>

<style>
:host {
  display: block;
}
</style>
